import { gql } from "@apollo/client";

export const GET_MOTIVOS_AJUSTE = gql`
    query motivosAjuste {
        motivosAjuste {
            idMotivoAjuste
            descripcion
            activo
        }
    }
`;